;(function($, trackEvents){

    var rnn = window.rnn, log, maps, forms, Form, Field;

    function showForm(submission){

        var contributeBar = this,
            isNextSubmission = contributeBar.nextSubmission === submission,
            showingLoginForm = contributeBar.currentForm && contributeBar.currentForm.type == 'login';

        // If the form for this submission is already open, then hide it.
        // This function should perhaps be called toggleForm instead of showForm.
        if (contributeBar.currentForm && contributeBar.currentForm.submission === submission) {
            contributeBar.hideForm(function() {
                contributeBar.nextSubmission = null;
                fadeShareBarOut();
            });
            return undefined;
        }

        // Hide any existing forms, providing a callback function to show
        // the requested form afterwards.
        contributeBar.hideForm(function(){
            rnn.modules.user.get(function(user){
                if(user.authenticated){
                    switch(submission.type){
                        case "story":
                            contributeBar.currentForm = new rnn.modules.ugc2.StoryForm({submission: submission});
                            break;
                        case "image":
                            contributeBar.currentForm = new rnn.modules.ugc2.ImageForm({submission: submission});
                            break;
                        case "notice":
                            contributeBar.currentForm = new rnn.modules.ugc2.NoticeForm({submission: submission});
                            break;
                        case "event":
                            window.location = rnn.site.addEventURL;
                            return;
                    }
                } else {

                    // If the login form is already showing and the user clicked on
                    // the button again, then hide the login form again and abort.
                    if(isNextSubmission && showingLoginForm) {
                        contributeBar.nextSubmission = null;
                        return false;
                    }

                    contributeBar.currentForm = new rnn.modules.login.LoginForm({title: "Log in to start sharing:"});
                    contributeBar.nextSubmission = submission;

                }

                // Add a close button to the form. For mobile it adds the header too.
                var closeButton;

                // Add a hidden form element to capture the recaptcha token
                var hiddenRecaptchaField = $('<input type="hidden" name="recaptchaToken" id="recaptchaToken" value="123">');

                if (rnn.site.isMobile) {
                    //Set up an appropriate title for mobile use
                    var navBarTitle;
                    if (contributeBar.currentForm.type == 'login') {
                        navBarTitle = "Log in";
                    } else if (contributeBar.currentForm.submission.type) {
                        navBarTitle = "Share your "+contributeBar.currentForm.submission.type;
                    } else {
                        navBarTitle = "Contribute";
                    }

                    //Set up a button for mobile
                    closeButton = $.el.button({"class":"btn closeModal closeContribute","type":"button"},"Back");

                    //Set up a submit button for mobile, assuming each form needs one.
                    //See ugcImages.js ugcNotices.js and ugcStories.js 'NOTE'.
                    var submitButton = $.el.button({'type':'submit', 'class':'submit btn btn-small btn-primary'}, "Submit");

                    var nav = $($.el.nav({"class":"menu"},
                            $.el.span({"class":"title"},navBarTitle),
                            closeButton,
                            submitButton
                        ));
                    $(contributeBar.currentForm.element).prepend(nav).append(hiddenRecaptchaField);

                } else {

                    if (contributeBar.currentForm.type === 'login') {
                        var divFormButton = $.el.div({'class':'group-login-button'});
                        closeButton = $.el.a({"class":"closeContribute icon-remove", "alt":"Close", "href":"#"});

                        //Set up a button for desktop
                        $(divFormButton).append(
                            closeButton,
                            submitButton = $.el.button({'type':'submit', 'class':'submit btn btn-primary'},
                                "Login"
                            )
                        );

                        var register = $.el.p({'class': 'new-register'}, 'New? ');
                        $(register).append($.el.a({href: rnn.site.registerURL}, 'Register here'));
                        $(register).append($.el.a({'class': 'pull-right', 'href': rnn.site.resetPasswordURL}, 'Forgot password?'));

                        //Add Facebook login button
                        var divFormFacebook = $.el.div({'class':'only-facebook-api'});
                        var para = $.el.p({'class': 'center-text margin-top-15 straight-line'});
                        $(para).append($.el.span({'class': 'grey-bubble'}, "or"));
                        var para1 = $.el.p({'class': 'center-text margin-top-24'});
                        var link = $.el.a({'class': 'fb-login-button', 'href': 'javascript:void(0);'}, 'Login with ');
                        $(link).append($.el.span({}, 'Facebook'));
                        $(para1).append(link);
                        var hiddenFacebook = $.el.input({'type': 'hidden', 'name': 'next', 'value': window.location.pathname, 'id': 'id_next'});
                        $(divFormFacebook).append(para, para1);
                        $(contributeBar.currentForm.element).append(divFormButton, hiddenFacebook, register, divFormFacebook);

                        rollLoginFormOut(); // Roll out login form

                    } else {
                        var divFormButton = $.el.div({'class':'group-for-form-button'});
                        closeButton = $.el.button({"class":"btn closeContribute", "type":"button"},
                                "Close"
                            );

                        //Set up a button for desktop
                        $(divFormButton).append(
                            closeButton,
                            $.el.button({'type':'submit', 'class':'submit btn btn-primary'},
                                "Submit your " + submission.type
                            )
                        );
                        $(divFormButton).on("click", function() { grecaptcha.execute(); return false; });
                        $(contributeBar.currentForm.element)
                            .append(divFormButton)
                            .append(hiddenRecaptchaField);
                    }
                }
                // Set up the bind to hide no matter which we have branched into above.
                $(closeButton).on('click', function(){
                    contributeBar.hideForm();

                    return false;
                });

                contributeBar.formArea.appendChild(contributeBar.currentForm.element);
                contributeBar.currentForm.init();

                if (contributeBar.currentForm.type === 'login') {
                    rnn.modules['facebook'].init();
                }

                if(submission.onShowCallbacks){
                    submission.onShowCallbacks.fastEach(function(callback){
                        callback();
                    });
                }

                //In mobile we active the form, rather than slide down.
                if (rnn.site.isMobile) {
                    $(contributeBar.element).find('.formContainer').addClass("active").show();
                } else {
                    var formContainer = $(contributeBar.element).find('.formContainer');
                    // formContainer.slideDown('fast'); -- COMMENTED OUT WITH SHARE BAR REMOVAL
                    if (contributeBar.currentForm.type === 'login') {
                        formContainer.addClass('loginContainer');
                    } else {
                        formContainer.removeClass('loginContainer');
                    }
                }
            });
        });
    }

    function hideForm(callback){
        var contributeBar = this;
        var $formElement = $(this.element).find('.formContainer');

        //Mobile does the right thing to it's modal
        if (rnn.site.isMobile && $formElement.length) {
            $formElement.removeClass("active");
            //Seriously... I can't just define a function for some reason here
            //without it just executing immediately and closing the form.

            //Same code as bellow
            (function (){
                if(contributeBar.currentForm){
                    var submission = contributeBar.currentForm.submission;
                    contributeBar.currentForm.destroy();

                    if (contributeBar.nextSubmission) {
                        contributeBar.nextSubmission.onHideCallbacks.fastEach(function(callback){
                            callback();
                        });
                    }
                    contributeBar.currentForm = null;

                    if(submission && submission.onHideCallbacks){
                        submission.onHideCallbacks.fastEach(function(callback){
                            callback();
                        });
                    }
                }
                callback && callback();
            })();
        } else {
            $formElement.slideUp('fast', function (){
                if(contributeBar.currentForm){

                    var submission = contributeBar.currentForm.submission;
                    contributeBar.currentForm.destroy();

                    /*
                    The callbacks to disable state of the buttons on the bar weren't happening when login forms were showing, because the
                    submission of the intended form is needed to fire those correctly. Here i use the intended 'next' form for those in place,
                    when the form that was current was a login form.
                    */
                    if (contributeBar.nextSubmission) {
                        contributeBar.nextSubmission.onHideCallbacks.fastEach(function(callback){
                            callback();
                        });
                    }
                    contributeBar.currentForm = null;

                    if(submission && submission.onHideCallbacks){
                        submission.onHideCallbacks.fastEach(function(callback){
                            callback();
                        });
                    }
                }
                callback && callback();
            });
        }
    }

    function createShareButton(contributeBar, submission){

        //Just some extra classes for mobile buttons to use
        var newButtonClass;
        if (rnn.site.isMobile) {
            newButtonClass = "btn btn-small";
        } else {
            newButtonClass = "";
        }

        var newButton = $.el.button({"type":"button","class":newButtonClass},
            $barElement = $(contributeBar.element),
            $buttonsContainer = $barElement.find('.formButtons'),
            submission.title
            ),
            buttonContainer;

        $(newButton).data('submission', submission);

        if(submission.isDefault){
            buttonContainer = $buttonsContainer.find('.defaultButtons')[0];
            if(!buttonContainer){
                $buttonsContainer.append(buttonContainer = $.el.span({"class":"defaultButtons"}));
            }
        }else{
            buttonContainer = $buttonsContainer.find('.contextButtons')[0];
            if(!buttonContainer){
                $buttonsContainer.append(buttonContainer = $.el.span({"class":"contextButtons"}));
            }
        }

        buttonContainer.appendChild(newButton);

        contributeBar.onSubmissionShow(submission, function(){
            $(newButton).addClass('active');
        });

        contributeBar.onSubmissionHide(submission, function(){
            $(newButton).removeClass('active');
        });
    }

    function rollLoginFormOut(){
        $(".contributeWrapper .loginForm").slideDown(500, function() {
            // Animation complete.
        });
    }

    function fadeShareBarOut(){
        $(".contribute .banner").fadeOut(500, function() {
            // Animation complete
            $(".contribute").animate({height: "0px"}, 300, function() {
                //Animation complete.
            });
        });
    }

    function rollMainFormUp(){
        $(".contributeWrapper .formContainer").slideUp(500, function() {
            // Animation complete
            fadeShareBarOut();
        });
    }

    function removeShareBar(){
        $(".contribute .contributeWrapper .closeContribute").click(function() {
            rollMainFormUp();
        });
    }

    function rollMainForm(){
        $(".contributeWrapper .formContainer").slideDown(500, function() {
            // Animation complete.
            removeShareBar();
        });
    }

    function formModifications(){
        $(".ugcCallToAction .showForm").click(function() {
            $(".contribute").animate({height: "48px"}, 300, function() {
                //Animation complete.

                $(".contribute .banner").fadeIn(500, function() {
                    // Animation complete.
                    rollMainForm();
                    if(rnn.site.isMobile === true){
                        $(".contribute").show();
                        $("html, body").animate({ scrollTop: 0 }, "slow");
                    }
                });
            });
        });
    }

    function initialiseContribute() {
        log = rnn.logging.log;
        maps = rnn.modules.maps;
        forms = rnn.modules.forms;
        Form = forms.Form;
        Field = forms.Field;

        function ContributeBar($target){
            this.create($target);
        }
        ContributeBar.prototype = {
            constructor: ContributeBar,
            create:function($target){
                var contributeBar = this,
                    $contributeElement;

                contributeBar.element = $.el.div({"class":"contribute"},
                    $.el.div({"class":"contributeWrapper"},
                        $.el.div({"class":"banner"},
                            $.el.div({"class":"formButtons"},
                                $.el.h2("Share your:")
                            )
                        ),
                        (contributeBar.formArea = $.el.div({"class":"formContainer apnform span8"}))
                    )
                );

                //Mobile needs some more selectors
                if (rnn.site.isMobile) {
                    $(contributeBar.formArea).removeClass("span8").addClass("mobileNoticeWrapper mobileModal");
                }

                $contributeElement = $(contributeBar.element);

                $contributeElement.find('.formContainer')
                    .hide().end()
                    .on('click', '.formButtons button', function(){
                        var targetButton = $(this),
                            submission = targetButton.data('submission');

                        trackEvents.track_event('share-bar-' + submission.type, 'click', '', '')

                        contributeBar.showForm(submission);
                        // Clicked button.
                        rollMainForm();
                    })
                    .on('submitsuccess', function(){
                        // rollMainFormUp();
                        contributeBar.hideForm();
                        fadeShareBarOut();
                        /* Comment back in if we want the success bar to dissappear after a few seconds.
                        var $successAlert = $(".alertWrapper").find(".alert-success");
                        if($successAlert !== null){
                            $successAlert.delay(3000).slideUp(500, function() {
                                // Animation complete
                                $successAlert.remove();
                            });
                        }
                        */
                    });

                $(rnn).on('login', function(){
                    if (contributeBar.nextSubmission) {
                        contributeBar.showForm(contributeBar.nextSubmission);
                        rollMainForm();
                    }
                });

                //Sticky to top of page but not for mobile
                if (!(rnn.site.isMobile)) {
                    var $window = $(window);

                    $window.on('scroll resize', function(){
                        if($contributeElement.offset().top < $window.scrollTop()){
                            if(!$contributeElement.hasClass('stuck')){
                                $contributeElement.addClass('stuck');
                            }
                        }else{
                            if($contributeElement.hasClass('stuck')){
                                $contributeElement.removeClass('stuck');
                            }
                        }
                    });
                }

                // Optionally set a context on the contribute bar itself.
                // Default submissions will fall back to this sometimes.
                contributeBar.context = $target.closest('[data-content-context]').data('content-context');

                $target.replaceWith(contributeBar.element);

            },
            showForm: showForm,
            hideForm: hideForm,
            registerSubmission: function(submission){
                this.submissions = this.submissions || [];
                this.submissions.push(submission);

                createShareButton(this, submission);
            },
            getSubmission: function(type, context){
                var foundSubmission;
                this.submissions.fastEach(function(submission){
                    if(
                        (
                            submission.context === context ||
                            (!context && submission.isDefault)
                        ) &&
                        submission.type === type
                    ){
                        foundSubmission = submission;
                        return true;
                    }
                });

                return foundSubmission;
            },
            onSubmissionShow: function(submission, callback){
                submission.onShowCallbacks = submission.onShowCallbacks || [];

                submission.onShowCallbacks.push(callback);
            },
            onSubmissionHide: function(submission, callback){
                submission.onHideCallbacks = submission.onHideCallbacks || [];

                submission.onHideCallbacks.push(callback);
            }
        };

        var contributeBar = new ContributeBar($('.contribute'));
        registerSubmissions(contributeBar);
        formModifications();
    }

    function registerSubmissions(contributeBar){

        // Create default submissions for the contribute bar.

        // Set the defaultContext using the contribute bar's context. This lets
        // the tagSelector populate default tags for Topic pages, or anywhere
        // with the contribute bar element within a context.

        // This should be plain "context" instead of "defaultContext" but I am
        // afraid of the side-effects of setting that on default submissions.
        // Lots of things in UGC hinge off contexts.

        var defaultForms = rnn.site.defaultContributeForms;
        defaultForms.fastEach(function(formName){
            contributeBar.registerSubmission({
                type: formName,
                defaultContext: contributeBar.context,
                title: formName.charAt(0).toUpperCase()+formName.slice(1),
                isDefault: true
            });
        });

        // Create additional submissions from any extra "call to actions" on the page.

        $('[data-call-to-action]').each(function(){
            var callToActionElement = $(this),
                submission,
                context = callToActionElement.closest('[data-content-context]').data('content-context'),
                callToActionData = callToActionElement.data("call-to-action");

                //we will possibly have a media request here we can pass through to be submitted, in order to provide a more specific link for the backend.
                //if you pass it, that's what'll get set. Otherwise it'll get it from the content_object.

            //////////////////////////////////////////////////////////////
            // A call to action MUST have a ugc-type,
            // and can OPTIONALY reference a content-context.
            // if no content-context is available, the default form
            // for the provided type will be used.
            // eg: notices always use the generic form, so a notice
            // call to action would provide only a type.
            //////////////////////////////////////////////////////////////

            submission = contributeBar.getSubmission(callToActionData.type, context);

            if(!submission){ // Create a new submission if there are none already registered with the same details
                submission = {
                    type: callToActionData.type,
                    context: context,
                    title: callToActionData.title,
                    description: $('<div/>').html(callToActionData.description).text()
                };
                contributeBar.registerSubmission(submission);
            }

            callToActionElement.find('.showForm.btn').each(function(){
                var $callToActionButton = $(this);
                $callToActionButton.click(function(){
                    contributeBar.showForm(submission);
                });

                contributeBar.onSubmissionShow(submission, function(){
                    $callToActionButton.addClass('active');
                });
                contributeBar.onSubmissionHide(submission, function(){
                    $callToActionButton.removeClass('active');
                });
            });
        });
        hideForFinda();
    }

    function hideForFinda(){
        //Don't want this to show on finda
        if (window.location.href.indexOf("classifieds") != -1)
        {
            $("div.contribute").hide();
        }
    }

    rnn.modules.register("contribute", {
        init: initialiseContribute
    });

})(jQuery, window.rnn.modules.trackEvents);
